import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex column items-start q-mr-sm" }
const _hoisted_2 = { class: "id-block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", { class: "q-mr-xs" }, "ID:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    "no-caps": "",
    flat: "",
    class: "profile-btn header__profile self-stretch q-pl-lg q-pr-lg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_icon, {
        name: _ctx.profileImagePath,
        class: "q-mr-sm overflow-hidden",
        style: {"border-radius":"100%"}
      }, null, 8, ["name"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_ctx.user?.email), 1),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.user?.data?.id), 1)
        ])
      ]),
      _createVNode(_component_q_icon, {
        name: _ctx.heroOutline24ChevronDown,
        size: "12px"
      }, null, 8, ["name"]),
      _createVNode(_component_q_menu, { fit: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, { style: {"min-width":"100px"} }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/profile')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('profile')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _ctx.logout
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('exit')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}